import HotelSearchActions from './HotelSearchActions'
import CONTENT from '../constants/Content'
import * as PCLNAnalytics from '../utils/PCLN-Analytics'
import { idleEnqueue } from '../utils/idle-until-urgent'

import {
  ANALYTICS_CATEGORY,
  ANALYTICS_ACTION_TAB,
  ANALYTICS_CATEGORY_HOTELS,
  ANALYTICS_CATEGORY_MOBILE
} from '../constants/Constants'

function fireHotelExpressDealLoaded () {
  PCLNAnalytics.send({
    event: 'gtm-pageload-event',
    category: ANALYTICS_CATEGORY,
    action: CONTENT.home.promos.expressDeals.loadedPromoAction,
    data: CONTENT.home.promos.expressDeals.loadedPromoLabel
  })
}

function openHotelExpressDealModal (e) {
  HotelSearchActions.toggleSOPQForm(true)

  PCLNAnalytics.send({
    category: ANALYTICS_CATEGORY,
    action: CONTENT.home.promos.expressDeals.linkTagAction,
    data: CONTENT.home.promos.expressDeals.linkTagLabel
  })

  if (e && e.preventDefault) {
    e.preventDefault()
  }
}

function firePromoLoadedAnalytics (action, data, category = ANALYTICS_CATEGORY) {
  PCLNAnalytics.send({
    event: 'gtm-pageload-event',
    category,
    action,
    data
  })
}

function fireAnalyticsOnPromoClick (action, data, category = ANALYTICS_CATEGORY) {
  PCLNAnalytics.send({
    category,
    action,
    data
  })
}

function fireSOPQModalOpen () {
  PCLNAnalytics.send({
    category: ANALYTICS_CATEGORY_HOTELS,
    action: CONTENT.home.forms.hotels.ga.displaySOPQAction,
    data: CONTENT.home.forms.hotels.ga.displayLabelModal
  })
}

function fireFormElementClick ({
  category = undefined,
  action = '',
  data = ''
}) {
  category = category || ANALYTICS_CATEGORY_HOTELS

  idleEnqueue(
    () => {
      PCLNAnalytics.send({
        category,
        action,
        data
      })
    }
  )
}

function fireSearchClick (label, data, category = ANALYTICS_CATEGORY_HOTELS, action = '') {
  PCLNAnalytics.send({
    category,
    action,
    data: label
  })
}

function downloadAndroidApp (e) {
  PCLNAnalytics.send({
    category: ANALYTICS_CATEGORY,
    action: CONTENT.home.promos.appDownload.linkTagAction,
    data: CONTENT.home.promos.appDownload.linkTagLabels.android
  })
}

function downloadiOSApp (e) {
  PCLNAnalytics.send({
    category: ANALYTICS_CATEGORY,
    action: CONTENT.home.promos.appDownload.linkTagAction,
    data: CONTENT.home.promos.appDownload.linkTagLabels.iOS
  })
}

function firePreselectedTab (product) {
  PCLNAnalytics.send({
    event: 'gtm-pageload-event',
    category: ANALYTICS_CATEGORY,
    action: ANALYTICS_ACTION_TAB,
    data: `Load ${product}`
  })
}

function fireGAOnAppOverlayLoad () {
  PCLNAnalytics.send({
    event: 'gtm-pageload-event',
    category: ANALYTICS_CATEGORY_MOBILE,
    action: 'AppOverlay Load'
  })
}

function firePromoSaleLoaded (action, label) {
  PCLNAnalytics.send({
    event: 'gtm-pageload-event',
    category: ANALYTICS_CATEGORY,
    action: action,
    data: label
  })
}

function promoSaleGA (action, label, clickUrl) {
  PCLNAnalytics.send({
    category: ANALYTICS_CATEGORY,
    action: action,
    data: label
  })
  clickUrl && window.open(clickUrl, '_blank')
}

function whyPricelineMobileGA (label) {
  PCLNAnalytics.send({
    category: 'PCLN_HOME',
    action: 'Why Priceline',
    data: label
  })
}

export {
  openHotelExpressDealModal,
  downloadAndroidApp,
  downloadiOSApp,
  fireHotelExpressDealLoaded,
  firePreselectedTab,
  fireGAOnAppOverlayLoad,
  fireFormElementClick,
  fireSOPQModalOpen,
  fireSearchClick,
  firePromoLoadedAnalytics,
  fireAnalyticsOnPromoClick,
  firePromoSaleLoaded,
  promoSaleGA,
  whyPricelineMobileGA
}
